/* unplugin-vue-components disabled */import { render } from "./dateSelect.vue?vue&type=template&id=708a047a&scoped=true"
import script from "./dateSelect.vue?vue&type=script&lang=js"
export * from "./dateSelect.vue?vue&type=script&lang=js"

import "./dateSelect.vue?vue&type=style&index=0&id=708a047a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708a047a"]])

export default __exports__